var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegramBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1192 2.26577C25.7245 4.85492 25.2717 7.87099 24.8045 10.8836C24.3626 13.7286 23.9112 16.5721 23.4501 19.414C23.3851 19.8133 23.3057 20.2195 23.1515 20.5929C22.7355 21.5883 21.7925 21.9163 20.8172 21.4462C17.7413 19.971 15.0377 17.9215 12.3214 15.8985C11.2788 15.1218 11.2989 14.4716 12.25 13.5608C14.4554 11.4475 16.6803 9.35199 18.8736 7.23176C19.3161 6.80369 20.1032 6.23292 19.6717 5.68402C19.296 5.20704 18.5612 5.87562 18.0871 6.18804C15.002 8.22312 11.9198 10.2651 8.8916 12.3836C7.66204 13.2438 6.4273 13.4141 5.04815 12.9785C3.78809 12.5775 2.52919 12.1845 1.27201 11.7766C0.823227 11.6299 0.308849 11.4889 0.265697 10.9095C0.223695 10.3416 0.679961 10.0551 1.10573 9.86867C2.77948 9.13507 4.47105 8.44118 6.15918 7.73981C11.9152 5.35472 17.6719 2.97212 23.4294 0.592022C23.6803 0.488456 23.9259 0.365903 24.186 0.295132C25.5795 -0.0840344 26.1802 0.395823 26.1192 2.26577Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramBlack);
export default __webpack_public_path__ + "static/media/telegramBlack.57ffd91838ce91ea89561e1837b44ca1.svg";
export { ForwardRef as ReactComponent };